import { SYNC_INSURANCE } from '@constants/index'
import { InsuranceUsage } from '@typesApp/ClaimData'
import { ClaimRecord } from '@typesApp/ClaimRecord'
import { DateUtil } from './dateUtil'

export type InsuranceUsageHandlerType = 'success' | 'timeExceeded' | 'error' | 'none'

export type InsuranceUsageHandlerCallback = (claimRecord?: ClaimRecord) => void

type HandleResultParams = {
  startTime: Date
  claimRecord: ClaimRecord
  handlers: Record<InsuranceUsageHandlerType, InsuranceUsageHandlerCallback>
}

type InsuranceUsageUtilReturn = {
  shouldPoll: (claimRecord: ClaimRecord) => boolean
  isResultReady: (claimRecord: ClaimRecord, startTime: Date) => boolean
  handleResult: (params: HandleResultParams) => void
}

const insuranceUsageUtil = (insuranceUsage: InsuranceUsage): InsuranceUsageUtilReturn => {
  const shouldPoll = (claimRecord: ClaimRecord) => {
    return insuranceUsage === claimRecord?.claimData?.useInsuranceStatus
  }

  const isSuccess = (claimRecord: ClaimRecord): boolean => {
    return insuranceUsage === claimRecord?.claimData?.useInsuranceStatus
  }

  const isResultReady = (claimRecord: ClaimRecord, startTime: Date): boolean => {
    if (!claimRecord) return false

    return isSuccess(claimRecord) || DateUtil.isMaxTimeExceeded({ startTime, maxTime: SYNC_INSURANCE.MAX_WAIT_TIME_MS })
  }

  const getResultHandlerType = (claimRecord: ClaimRecord, startTime: Date): InsuranceUsageHandlerType => {
    if (isSuccess(claimRecord)) {
      return 'success'
    } else if (DateUtil.isMaxTimeExceeded({ startTime, maxTime: SYNC_INSURANCE.MAX_WAIT_TIME_MS })) {
      return 'timeExceeded'
    }
    return 'none'
  }

  const handleResult = (params: HandleResultParams) => {
    const { startTime, claimRecord, handlers } = params
    const resultType = getResultHandlerType(claimRecord, startTime)
    handlers[resultType]?.(claimRecord)
  }

  return {
    shouldPoll,
    isResultReady,
    handleResult,
  }
}

export const InsuranceUsageUtil = {
  getUtil: (insuranceUsage: InsuranceUsage) => insuranceUsageUtil(insuranceUsage),
}
